import React, { useRef } from 'react';
import { useTheme, alpha } from '@mui/material/styles';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemLink from './list-item-link';
import { StyledListItemText, TrailListContainer } from './styles';
import { isTrailLabel } from '#helper';

const TrailList = ({ page, onMouseLeave, closeSubMenu, expanded, parentItemRef }) => {
  const offsetTop = parentItemRef?.current?.offsetTop;
  return (
    <TrailListContainer
      onMouseLeave={onMouseLeave}
      className="sub-menu"
      style={{ top: (offsetTop + 66) }}
    >
      {!expanded ?
        <ListItemLink disabled>
          <StyledListItemText primary="Audit trail" />
        </ListItemLink> : null}
      {page.subMenuList?.map(subPage => (
        <div key={subPage.label}>
          <ListItemLink
            to={subPage.route}
            onClick={closeSubMenu}
            aria-label={subPage.label}
          >
            <StyledListItemText primary={subPage.label} />
          </ListItemLink>
        </div>
      ))}
    </TrailListContainer>);
};

const DesktopListItem = ({
  page,
  subMenu,
  setItemsState,
  expanded,
  selected
}) => {
  const theme = useTheme();
  const listItemRef = useRef();

  const closeTrailSubMenu = () => {
    setItemsState(prevState => ({
      ...prevState,
      'Audit trail': false
    }));
  };

  const onTrailMouseLeave = event => {
    event.stopPropagation();
    try {
      const nextElementKey = event.relatedTarget.innerText || event.relatedTarget.getAttribute('data-key');
      if (!isTrailLabel(nextElementKey)) {
        closeTrailSubMenu();
      }
    } catch (error) {
      closeTrailSubMenu();
    }
  };

  const onMouseEnterHandler = () => {
    setItemsState(prevState => ({
      ...prevState,
      [page.label]: true
    }));
  };

  const onMouseLeaveHandler = () => {
    setItemsState(prevState => ({
      ...prevState,
      [page.label]: false
    }));
  };

  return (
    <div
      onMouseEnter={onMouseEnterHandler}
      onMouseLeave={onMouseLeaveHandler}
      data-key={page.label}
      key={page.label}
      ref={listItemRef}
      style={{ backgroundColor: `${selected ? alpha(theme.palette.secondary.main, 0.25) : '#FFF'}` }}
    >
      {page.divider}
      <ListItemLink
        onClickHandler={page.onClickHandler ?? null}
        to={page.route}
        tooltip={!expanded && !subMenu ? page.label : null}
        aria-label={page.label}
      >
        <ListItemIcon data-key={page.label}>{page.icon}</ListItemIcon>
        <StyledListItemText primary={page.label} />
      </ListItemLink>
      {subMenu ?
        <TrailList
          page={page}
          onMouseLeave={onTrailMouseLeave}
          closeSubMenu={closeTrailSubMenu}
          expanded={expanded}
          parentItemRef={listItemRef}
        /> :
        null}
    </div>
  );
};

export default DesktopListItem;
